import React, { useEffect, useState } from "react";


import {
    Row, Col
} from "react-bootstrap";


import UserDashboardSubmitRequestStartStepComponent from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Start";
import UserDashboardSubmitRequestStepsComponent from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Steps";
import UserDashboardSubmitRequestFinalStepComponent from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Summary";
import {QyvoUserAddressDataInterface, QyvoUserDataInterface} from "@Models/@API";
import {DefaultLoaderComponent} from "@Elements";
import {UseQyvoUser} from "@Store/@Hooks";


import IconPlaneSmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Icons/icon-plane-sm-grey.svg";
import IconBaggageSmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Icons/icon-baggage-sm-grey.svg";
import IconMonetizationSmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Icons/icon-monetization-sm-grey.svg";
import IconSecuritySmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Icons/icon-security-sm-grey.svg";
import IconExclamationSmGrey from "@Pages/@@UserPages/@@Dashboard/@@SubmitRequest/@Icons/icon-exclamation-sm-grey.svg";
import {FileWithPath} from "react-dropzone";


interface RefundOptionInterface {
    refundTypeId: number;
    refundTypeName: string;
}

interface RefundOptionsCategoryInterface {
    refundOptionsCategoryId: number;
    refundOptionsCategoryName: string;
    refundOptionsCategoryIcon: string;
    refundOptionsCategoryOptions: RefundOptionInterface[];
}

const RefundOptions:RefundOptionsCategoryInterface[] = [
    {
        refundOptionsCategoryId: 1,
        refundOptionsCategoryName: 'Flight Problems (EU261 Compensation)',
        refundOptionsCategoryIcon: IconPlaneSmGrey,
        refundOptionsCategoryOptions: [
            { refundTypeId: 1, refundTypeName: 'Flight Delay greater than 3 Hours' },
            { refundTypeId: 2, refundTypeName: 'Flight Cancellation (less than 14 Days)' },
            { refundTypeId: 3, refundTypeName: 'Missed Connection (Same PNR)' },
            { refundTypeId: 4, refundTypeName: 'Denied Boarding' },
            { refundTypeId: 5, refundTypeName: 'Involuntary Downgrade' },
        ],
    },
    {
        refundOptionsCategoryId: 2,
        refundOptionsCategoryName: 'Baggage Problems (Montreal Convention)',
        refundOptionsCategoryIcon: IconBaggageSmGrey,
        refundOptionsCategoryOptions: [
            { refundTypeId: 11, refundTypeName: 'Delayed Bag' },
            { refundTypeId: 12, refundTypeName: 'Lost Bag' },
            { refundTypeId: 13, refundTypeName: 'Damaged Bag' },
        ],
    },
    {
        refundOptionsCategoryId: 3,
        refundOptionsCategoryName: 'Refunds (Fees, Taxes, Ancillaries)',
        refundOptionsCategoryIcon: IconMonetizationSmGrey,
        refundOptionsCategoryOptions: [
            { refundTypeId: 6, refundTypeName: 'Refund of Airport Taxes & Fees-Unused Ticket taxes' },
            { refundTypeId: 7, refundTypeName: 'Paid Seat Not Delivered (Seat Assignment Lost or Changed)' },
            { refundTypeId: 8, refundTypeName: 'Priority Boarding Not Provided' },
            { refundTypeId: 9, refundTypeName: 'Onboard Wi-Fi Not Working' },
            { refundTypeId: 10, refundTypeName: 'Lounge Access Denied' },
            { refundTypeId: 16, refundTypeName: 'Refund of Unused Ancillary Fees' },
            { refundTypeId: 19, refundTypeName: 'Refund of Taxes for Unused Flight Segment(s)' },
            { refundTypeId: 20, refundTypeName: 'Rebooking Downgrade (Non-EU Travel)' },
        ],
    },
    {
        refundOptionsCategoryId: 4,
        refundOptionsCategoryName: 'U.S. DOT Protected Refunds',
        refundOptionsCategoryIcon: IconSecuritySmGrey,
        refundOptionsCategoryOptions: [
            { refundTypeId: 14, refundTypeName: 'Cancelled Flight Refund' },
            { refundTypeId: 15, refundTypeName: 'Significant Schedule Change Refund' },
            { refundTypeId: 17, refundTypeName: 'Tarmac Delay Compensation' },
        ],
    },
    {
        refundOptionsCategoryId: 5,
        refundOptionsCategoryName: 'Trip Interruption Expenses',
        refundOptionsCategoryIcon: IconExclamationSmGrey,
        refundOptionsCategoryOptions: [
            { refundTypeId: 21, refundTypeName: 'Hotel costs due to overnight delays' },
            { refundTypeId: 22, refundTypeName: 'Transportation to/from hotel (taxi, Uber, shuttle, bus)' },
            { refundTypeId: 23, refundTypeName: 'Meals, drinks, and snacks during extended disruptions' },
            { refundTypeId: 24, refundTypeName: 'Transportation between airports when rebooked' },
            { refundTypeId: 25, refundTypeName: 'Clothing and essential items if stranded without baggage' },
            { refundTypeId: 26, refundTypeName: 'Replacement flight costs (if you had to rebook yourself)' },
            { refundTypeId: 27, refundTypeName: 'Lost prepaid reservations (hotel nights, tours, transfers)' },
            { refundTypeId: 28, refundTypeName: 'Ground transportation costs caused by missed or changed flights' },
            { refundTypeId: 29, refundTypeName: 'Additional fees paid because of irregular operations (airport parking, pet fees, etc.)' },
            { refundTypeId: 30, refundTypeName: 'Any necessary, reasonable expenses caused directly by airline delay or cancellation' },
        ],
    },
    // { refundTypeId: 18, refundTypeName: 'Trip Interruption Expenses (EU Consumer Law + Contract Law)' },
];


export type RefundOptionsObjectType = {
    [key: number]: string;
};


export interface RefundOptionsCategoriesObjectType {
    refundOptionsCategoryId: number;
    refundOptionsCategoryName: string;
    refundOptionsCategoryIcon: string;
    refundOptionsCategoryOptions: {
        [key: number]: string;
    };
}


export const RefundOptionsCategoriesObject:RefundOptionsCategoriesObjectType[] = RefundOptions.map((refundCategory) => {
    return {
        ...refundCategory,
        refundOptionsCategoryOptions: refundCategory.refundOptionsCategoryOptions.reduce(
            (optionsObject, refundOption) =>
                Object.assign(optionsObject, {
                    [refundOption.refundTypeId]: refundOption.refundTypeName
                }), {}
        )
    };
});

// export const RefundOptionsObject:RefundOptionsObjectType = RefundOptions.reduce(
//     (optionsObject, refundOption) =>
//         Object.assign(optionsObject, {
//             [refundOption.refundTypeId]: refundOption.refundTypeName
//         }), {}
// );


interface UserPersonalDataInterface {
    userFirstName: string;
    userLastName: string;
    userAddressStreet: string;
    userAddressHouseNo: string;
    userAddressPostCode: string;
    userAddressCityOrTown: string;
}


interface UserUploadedDocumentInterface {
    userDocumentName: string;
    userDocumentSize: number;
}


export interface UserSubmitRequestDataInterface {
    refundOptionsStep: number[];
    attachedDocumentsStep: {
        documentsList: UserUploadedDocumentInterface[];
    };
    personalDataStep: UserPersonalDataInterface;
    signatureStep: {
        signatureType?: 'DIGITAL' | 'ELECTRONIC';
        signatureSrc?: string;
    };
}


export const UserSubmitRequestDataDefaults:UserSubmitRequestDataInterface = {
    refundOptionsStep: [],
    attachedDocumentsStep: {
        documentsList: []
    },
    personalDataStep: {
        userFirstName: '',
        userLastName: '',
        userAddressStreet: '',
        userAddressHouseNo: '',
        userAddressPostCode: '',
        userAddressCityOrTown: ''
    },
    signatureStep: {
        signatureType: undefined,
        signatureSrc: ''
    }
};


export const UserDashboardSubmitRequestPageComponent:React.FC = () => {


    const [userSubmitRequestStep, setUserSubmitRequestStep] = React.useState(0);

    useEffect(() => {
        const storedUserSubmitRequestStep = localStorage.getItem('storedUserSubmitRequestStep') || 0;
        setUserSubmitRequestStep(+storedUserSubmitRequestStep);
    }, []);

    useEffect(() => {
        return () => {
            setUserSubmitRequestStep(0);
        };
    }, []);

    const changeUserSubmitRequestStep = (userSubmitRequestStep: number) => {
        if (userSubmitRequestStep === 6) {
            localStorage.removeItem('storedUserSubmitRequestStep');
        } else {
            localStorage.setItem('storedUserSubmitRequestStep', userSubmitRequestStep.toString());
        }
        setUserSubmitRequestStep(userSubmitRequestStep);
    };


    const [userSubmitRequestData, setUserSubmitRequestData] = useState<UserSubmitRequestDataInterface>(UserSubmitRequestDataDefaults);

    useEffect(() => {
        const storedUserSubmitRequestData = localStorage.getItem('storedUserSubmitRequestData');
        if (storedUserSubmitRequestData) {
            setUserSubmitRequestData(
                JSON.parse(storedUserSubmitRequestData)
            );
        }
    }, []);

    const changeUserSubmitRequestData = (userSubmitRequestData: UserSubmitRequestDataInterface) => {
        localStorage.setItem('storedUserSubmitRequestData', JSON.stringify(userSubmitRequestData));
        setUserSubmitRequestData({ ...userSubmitRequestData });
    };


    const QyvoUser = UseQyvoUser();

    const [QyvoUserData, setQyvoUserData] = useState<QyvoUserDataInterface | null>(null);
    const [QyvoUserAddressData, setQyvoUserAddressData] = useState<QyvoUserAddressDataInterface | null>(null);

    useEffect(() => {

        if (!QyvoUserData) {
            const getQyvoUserData = async () => {
                try {
                    const response = await fetch(
                        `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-user-by-email/?user_email=${QyvoUser?.qyvoUserEmail}&user_data=true`
                    );
                    if (response.ok) {
                        const responseData = await response.json();
                        setQyvoUserData(responseData);
                    }
                } catch (e) {
                    console.error(e);
                }
            };
            getQyvoUserData();
        }

        if (!QyvoUserAddressData) {
            const getQyvoUserAddressData = async () => {
                try {
                    const response = await fetch(
                        `https://qyvo-engine.webpros.pl/api/v1/qyvo-users/get-qyvo-user-address-data/?qyvo_user_email=${QyvoUser?.qyvoUserEmail}`
                    );
                    if (response.ok) {
                        const responseData = await response.json();
                        setQyvoUserAddressData(responseData);
                    }
                } catch (e) {
                    console.log(e);
                }
            };
            getQyvoUserAddressData();
        }

    }, [QyvoUser, QyvoUserAddressData, QyvoUserData]);

    useEffect(() => {

        if (!QyvoUserData || !QyvoUserAddressData) {
            return;
        }

        const {
            qyvo_user_first_name: qyvoUserFirstName, qyvo_user_last_name: qyvoUserLastName
        } = QyvoUserData;

        const {
            qyvo_user_address_street: qyvoUserAddressStreet, qyvo_user_address_house_no: qyvoUserAddressHouseNo,
            qyvo_user_address_postal_code: qyvoUserAddressPostCode, qyvo_user_address_city: qyvoUserAddressCityOrTown
        } = QyvoUserAddressData;

        userSubmitRequestData.personalDataStep = {
            userFirstName: qyvoUserFirstName, userLastName: qyvoUserLastName,
            userAddressStreet: qyvoUserAddressStreet ?? '', userAddressHouseNo: qyvoUserAddressHouseNo ?? '',
            userAddressPostCode: qyvoUserAddressPostCode ?? '', userAddressCityOrTown: qyvoUserAddressCityOrTown ?? ''
        };

    }, [QyvoUserAddressData, QyvoUserData, userSubmitRequestData]);


    const [
        qyvoUserClaimAttachedFiles, setQyvoUserClaimAttachedFiles
    ] = useState<File[]>([]);

    useEffect(() => {
        return () => {
            setQyvoUserClaimAttachedFiles([]);
        };
    }, []);


    const submitClaimRequestHandler = async () => {



    };


    if (!QyvoUserData && !QyvoUserAddressData) {
        return <DefaultLoaderComponent />;
    }


    console.log(qyvoUserClaimAttachedFiles);


    return (
        <Col xs={12} className={`user-dashboard-submit-request-container`}>
            <Row className={`user-dashboard-submit-request-container__container-content`}>

                {userSubmitRequestStep === 0 &&
                <UserDashboardSubmitRequestStartStepComponent
                    userSubmitRequestStepSetter={changeUserSubmitRequestStep}
                />
                }

                {(userSubmitRequestStep > 0 && userSubmitRequestStep < 6) &&
                <UserDashboardSubmitRequestStepsComponent
                    userSubmitRequestStepNumber={userSubmitRequestStep}
	                userSubmitRequestStepSetter={changeUserSubmitRequestStep}
                    userSubmitRequestData={userSubmitRequestData}
                    userSubmitRequestDataSetter={changeUserSubmitRequestData}
                    userSubmitRequestAttachedFilesList={qyvoUserClaimAttachedFiles}
                    userSubmitRequestAttachedFilesListSetter={(filesList: File[]) => setQyvoUserClaimAttachedFiles(filesList)}
                />
                }

                {userSubmitRequestStep === 6 &&
                <UserDashboardSubmitRequestFinalStepComponent />
                }

            </Row>
        </Col>
    );

};


export default UserDashboardSubmitRequestPageComponent;
